module.exports = "//static.hsappstatic.net/marketplace-unified-public-base/static-1.478/img/cms-free-signup-2x.png"